import Tags from './Tags';
export * from './templates';
export * from './types';

export default Tags;
